import type userCenterZh from '../zh/userCenter';

const userCenter: typeof userCenterZh = {
  tab_profile: 'Thông tin cá nhân',
  tab_security: 'Bảo mật tài khoản',
  tab_orders: 'Lịch sử đặt mua',
  profile_saved: 'Đã lưu thông tin cá nhân',
  password_mismatch: 'Hai lần nhập mật khẩu mới không khớp',
  password_updated: 'Đã cập nhật mật khẩu',
  order_detail_pending: 'Chi tiết đơn (chờ kết nối)',
  basic_info: 'Thông tin cơ bản',
  org_id: 'ID tổ chức',
  phone: 'Số điện thoại',
  phone_required: 'Vui lòng nhập số điện thoại',
  phone_invalid: 'Vui lòng nhập số điện thoại hợp lệ',
  platform_email: 'Email nền tảng',
  wowbit_assigned: 'Wowbit cấp',
  plan_section: 'Gói hiện tại',
  addon_section: 'Gói quyền lợi riêng',
  addon_shop: 'Suất cửa hàng mua thêm',
  addon_shop_unit: 'suất',
  addon_dm: 'Tin nhắn',
  addon_invite: 'Lời mời',
  addon_mail: 'Email',
  addon_remain_before: 'còn',
  addon_remain_after: '',
  addon_load_failed: 'Không tải được gói quyền lợi riêng',
  current_plan: 'Gói hiện tại',
  expire_remain: 'Có hiệu lực đến {{date}} · còn {{days}} ngày',
  go_renew: 'Gia hạn',
  go_upgrade: 'Nâng cấp ngay',
  renew_pending: 'Gia hạn (chờ kết nối)',
  shop_slots: 'Suất cửa hàng',
  shop_total: 'Tổng {{count}}',
  shop_used: '{{used}} / {{limit}}',
  addon: 'Mua thêm',
  addon_shop_pending: 'Mua thêm suất cửa hàng (chờ kết nối)',
  email_quota: 'Hạn mức email',
  unlimited: 'Không giới hạn',
  email_total: 'Tổng {{total}} email/tháng',
  email_used: '{{used}} / {{limit}} email',
  addon_email_pending: 'Mua thêm hạn mức email (chờ kết nối)',
  save_changes: 'Lưu thay đổi',
  change_password: 'Đổi mật khẩu',
  login_methods: 'Phương thức đăng nhập',
  unbind: 'Hủy liên kết',
  change: 'Đổi liên kết',
  bind: 'Liên kết',
  bind_phone_title: 'Liên kết số điện thoại',
  bind_email_title: 'Liên kết email đăng nhập',
  bind_confirm: 'Xác nhận liên kết',
  bind_hint: 'Mã xác minh sẽ được gửi tới liên hệ này. Sau khi liên kết có thể dùng nó để đăng nhập.',
  bind_success: 'Đã liên kết',
  bind_failed: 'Liên kết thất bại',
  bind_phone_placeholder: 'Nhập số điện thoại',
  bind_email_placeholder: 'Nhập email đăng nhập',
  unbind_phone_title: 'Hủy liên kết số điện thoại',
  unbind_email_title: 'Hủy liên kết email đăng nhập',
  unbind_confirm: 'Xác nhận hủy liên kết',
  unbind_hint:
    'Mã xác minh sẽ được gửi tới liên hệ này. Sau khi hủy sẽ không đăng nhập bằng nó được. Hãy giữ ít nhất một phương thức đăng nhập khác.',
  unbind_code_invalid: 'Vui lòng nhập mã xác minh 6 chữ số',
  unbind_identity_missing: 'Không có liên hệ để hủy liên kết',
  unbind_success: 'Đã hủy liên kết',
  unbind_failed: 'Hủy liên kết thất bại',
  unbind_unavailable: 'Không có liên hệ để hủy liên kết',
  change_phone_title: 'Đổi số điện thoại',
  change_email_title: 'Đổi email đăng nhập',
  change_confirm: 'Xác nhận đổi',
  change_hint: 'Hãy lấy mã BINDING cho cả liên hệ cũ và mới trước khi gửi.',
  change_old_identity: 'Liên hệ hiện tại',
  change_old_code: 'Mã của liên hệ cũ',
  change_new_identity: 'Liên hệ mới',
  change_new_code: 'Mã của liên hệ mới',
  change_phone_placeholder: 'Nhập số điện thoại mới',
  change_email_placeholder: 'Nhập email đăng nhập mới',
  change_email_invalid: 'Vui lòng nhập email hợp lệ',
  change_same_identity: 'Liên hệ mới phải khác liên hệ hiện tại',
  change_success: 'Đã đổi liên kết',
  change_failed: 'Đổi liên kết thất bại',
  current_password: 'Mật khẩu hiện tại',
  current_password_required: 'Vui lòng nhập mật khẩu hiện tại',
  new_password: 'Mật khẩu mới',
  new_password_required: 'Vui lòng nhập mật khẩu mới',
  password_rule: 'Ít nhất 8 ký tự, không chứa khoảng trắng và không quá 72 byte UTF-8',
  current_password_rule: 'Mật khẩu hiện tại không quá 72 ký tự và 72 byte UTF-8',
  password_change_failed: 'Đổi mật khẩu thất bại',
  password_changed_relogin: 'Đã cập nhật mật khẩu, vui lòng đăng nhập lại',
  strength: 'Độ mạnh mật khẩu: {{level}}',
  strength_weak: 'Yếu',
  strength_mid: 'Trung bình',
  strength_strong: 'Mạnh',
  confirm_password: 'Xác nhận mật khẩu mới',
  confirm_password_required: 'Vui lòng nhập lại mật khẩu mới',
  order_packages: 'Đơn mua gói',
  order_benefits: 'Đơn quyền lợi riêng',
  col_order_no: 'Mã đơn',
  col_package: 'Gói',
  col_amount: 'Số tiền',
  col_status: 'Trạng thái',
  col_purchased_at: 'Thời gian mua',
  col_actions: 'Thao tác',
  status_completed: 'Đã hoàn thành',
  status_pending: 'Chờ thanh toán',
  status_cancelled: 'Đã hủy',
  orders_load_failed: 'Không tải được lịch sử mua',
  fulfillment_PENDING: 'Chờ cấp quyền',
  fulfillment_FULFILLED: 'Đã cấp quyền',
  fulfillment_MANUAL_REVIEW: 'Chờ xử lý',
  order_days: '{{days}} ngày'
};

export default userCenter;
